import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiAlertCircle } from "react-icons/fi";
import { goToLogin } from "../../../routes/coordinator";
import { customColors } from "../../../atoms/customColors";
import { useSetRecoilState, useRecoilState } from "recoil";
import { useCookies } from "react-cookie";

const ModalLogout = ({ isOpen, setIsOpen }: any) => {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const colors = useRecoilState(customColors)[0];
  const [cookies, setCookie, removeCookie] = useCookies();

  const onClose = () => {
    setIsOpen(false);
  };

  const logout = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("user");
    removeCookie("auth");
    removeCookie("token");
    removeCookie("refreshToken");
    goToLogin(navigate);
    window.location.reload();
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            w={"100%"}
            h={"110px"}
          >
            {<FiAlertCircle color={colors.REDMONEDD} size={70} />}
          </Box>
          <ModalBody>
            <Box
              h={"70px"}
              justifyContent={"center"}
              textAlign={"center"}
              alignContent={"center"}
            >
              <Text fontSize="2xl">Deseja sair do sistema?</Text>
            </Box>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={colors.GRAY_LIGHT} mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button
              background={colors.REDMONEDD}
              color={colors.WHITE}
              onClick={logout}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalLogout;
